import React from 'react';
import PropTypes from 'prop-types';

import './Notification.css';

class Notification extends React.PureComponent {
	render() {
		const {
			notificationMsg,
			isNotificationDisplayed,
			hideNotification
		} = this.props;

		return (
			<div
				className={`premium-notification ${isNotificationDisplayed ? 'show' : ''}`}
			>
				<div className="notification-content">
					<div className="notification-icon">
						<i className="material-icons">info_outline</i>
					</div>
					<div className="notification-message">
						{notificationMsg}
					</div>
					<button className="notification-close" onClick={hideNotification}>
						<i className="material-icons">close</i>
					</button>
				</div>
				<div className="notification-progress"></div>
			</div>
		);
	}
}

Notification.propTypes = {
	isNotificationDisplayed: PropTypes.bool.isRequired,
	notificationMsg: PropTypes.string,
	hideNotification: PropTypes.func.isRequired
};

export default Notification;

